/** @jsxImportSource @gongxigames/framework/core/fragments/BuilderY */
/** @jsxRuntime automatic */

import {FC, getProp, $Container} from '@gongxigames/framework/core/fragments/BuilderY';
import {$Button} from '@gongxigames/framework/slotV2/ui/ui-koala/JSX/Button';
import {BetSelectProps, BetSelectActions, computedDisableMinus, computedDisablePlus} from './etc';
import {Rectangle} from 'pixi.js';

const HIT_AREA = new Rectangle(-110/2, -76/2, 110, 76);

export const $BetSelectLandscape: FC<BetSelectProps> = (props) => {
    const disablePlus = computedDisablePlus(props);
    const disableMinus = computedDisableMinus(props);

    function callAction(action: BetSelectActions) {
        getProp(props.action)?.(action);
    }

    return <$Container name='bet_select_landscape' {...props}>
        <$Button
            name='mini_minus_btn'
            hitArea={HIT_AREA}
            action={callAction.bind(null, 'decrease')}
            disabled={disableMinus}
            responsive={{
                box: {x: '-57px'},
            }}
        />
        <$Button
            name='mini_plus_btn'
            hitArea={HIT_AREA}
            action={callAction.bind(null, 'increase')}
            disabled={disablePlus}
            responsive={{
                box: {x: '57px'},
            }}
        />

    </$Container>;
};